import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { IoMdClose } from 'react-icons/io';

import styles from './Modal.module.css';

const modalRoot = document.getElementById('modal');

export default function Modal({ children, closeCB, title, footer, size = 'medium' }) {
    const el = useRef(document.createElement('div'));
    const modalRef = useRef(null);

    // Focus management
    useEffect(() => {
        const container = el.current;
        modalRoot.appendChild(container);

        // Focus the modal when it opens
        if (modalRef.current) {
            modalRef.current.focus();
        }

        // Prevent body scroll
        document.body.style.overflow = 'hidden';

        return () => {
            modalRoot.removeChild(container);
            document.body.style.overflow = 'unset';
        };
    }, []);

    const wrapContent = () => {
        return (
            <div
                className={styles.modalOverlay}
                role='dialog'
                aria-modal='true'
                aria-labelledby={title ? 'modal-title' : undefined}
            >
                <div
                    ref={modalRef}
                    className={`${styles.modal} ${styles[`modal--${size}`]}`}
                    tabIndex='-1'
                    role='document'
                >
                    {title && (
                        <div className={styles.modalHeader}>
                            <h2 id='modal-title' className={styles.modalTitle}>
                                {title}
                            </h2>
                            <button
                                type='button'
                                className={styles.closeButton}
                                onClick={closeCB}
                                aria-label='Close modal'
                            >
                                <IoMdClose size='1.2em' />
                            </button>
                        </div>
                    )}

                    <div className={styles.modalBody}>{children}</div>

                    {footer && <div className={styles.modalFooter}>{footer}</div>}
                </div>
            </div>
        );
    };

    return createPortal(wrapContent(), el.current);
}
